module.exports = __webpack_public_path__ + "static/media/banner_img.a3c22e67.png";